module.exports = __webpack_public_path__ + "media/images/bnr_special_shrine_temple-9dbf3b43df013b839839030c8d04fc08.jpg";